module.exports = __webpack_public_path__ + "static/media/footer-social-yout.a04938a0.png";